var _g, _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGhostRefreshingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 75,
    viewBox: "0 0 88 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4079_50468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4408 33.5465C16.4408 18.6071 28.5517 6.5 43.4873 6.5C58.4229 6.5 70.5338 18.6071 70.5338 33.5465V64.3732C70.5338 65.5174 69.129 66.0725 68.3473 65.2342L64.9749 61.6202C64.3065 60.9064 63.1925 60.8536 62.4599 61.4993L58.2152 65.2568C57.5317 65.8611 56.5083 65.8611 55.8248 65.2568L51.4592 61.3936C50.7757 60.7894 49.7523 60.7894 49.0688 61.3936L44.7033 65.2568C44.0198 65.8611 42.9964 65.8611 42.3128 65.2568L37.9473 61.3936C37.2638 60.7894 36.2404 60.7894 35.5569 61.3936L31.1914 65.2606C30.5116 65.8648 29.4844 65.8648 28.8047 65.2606L24.5298 61.4918C23.7972 60.846 22.6869 60.8989 22.0223 61.6126L18.6198 65.2455C17.8381 66.0801 16.437 65.5287 16.437 64.3845V33.5503L16.4408 33.5465Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5675 40.0472C42.3665 35.704 40.3041 30.7248 35.9609 28.9258C31.6177 27.1268 26.6384 29.1892 24.8394 33.5324C23.0404 37.8756 25.1029 42.8549 29.4461 44.6539C33.7893 46.4529 38.7685 44.3904 40.5675 40.0472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5076 38.3922C32.6433 38.3922 34.3747 36.6609 34.3747 34.5252C34.3747 32.3895 32.6433 30.6582 30.5076 30.6582C28.372 30.6582 26.6406 32.3895 26.6406 34.5252C26.6406 36.6609 28.372 38.3922 30.5076 38.3922Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8062 35.2638C35.2149 34.2773 34.7464 33.1462 33.7598 32.7376C32.7733 32.3289 31.6422 32.7974 31.2336 33.784C30.8249 34.7705 31.2934 35.9016 32.28 36.3102C33.2665 36.7189 34.3976 36.2504 34.8062 35.2638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0128 40.0531C63.8118 35.7099 61.7494 30.7307 57.4062 28.9316C53.063 27.1326 48.0837 29.1951 46.2847 33.5383C44.4857 37.8815 46.5482 42.8607 50.8914 44.6597C55.2346 46.4587 60.2138 44.3963 62.0128 40.0531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.95 38.3922C54.0857 38.3922 55.8171 36.6609 55.8171 34.5252C55.8171 32.3895 54.0857 30.6582 51.95 30.6582C49.8143 30.6582 48.083 32.3895 48.083 34.5252C48.083 36.6609 49.8143 38.3922 51.95 38.3922Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.252 35.2677C56.6607 34.2812 56.1922 33.1501 55.2056 32.7415C54.2191 32.3328 53.088 32.8013 52.6794 33.7879C52.2707 34.7744 52.7392 35.9055 53.7258 36.3141C54.7123 36.7228 55.8434 36.2543 56.252 35.2677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4129 48.7136C15.697 47.6676 12.9893 46.2401 10.9991 43.8723C9.06185 41.5687 8.01202 38.6118 7.07547 35.0205L11.4599 33.8762C12.37 37.3694 13.2234 39.4766 14.4696 40.9532C15.6592 42.3655 17.4077 43.438 20.644 44.3519L19.4167 48.7136H19.4129ZM7.07547 35.0205C6.75825 33.8082 7.48332 32.5734 8.69554 32.2561C9.90776 31.9389 11.1426 32.664 11.4599 33.8762L7.07547 35.0205ZM20.644 44.3481C21.8487 44.688 22.5511 45.938 22.2112 47.1427C21.8714 48.3473 20.6214 49.0497 19.4167 48.7099L20.644 44.3481Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8488 48.7136C71.5647 47.6676 74.2724 46.2401 76.2626 43.8723C78.1999 41.5687 79.2497 38.6118 80.1862 35.0205L75.8018 33.8762C74.8917 37.3694 74.0383 39.4766 72.7921 40.9532C71.6025 42.3655 69.854 43.438 66.6177 44.3519L67.845 48.7136H67.8488ZM80.19 35.0205C80.5072 33.8082 79.7822 32.5734 78.5699 32.2561C77.3577 31.9389 76.1228 32.664 75.8056 33.8762L80.19 35.0205ZM66.6177 44.3481C65.413 44.688 64.7106 45.938 65.0505 47.1427C65.3903 48.3473 66.6403 49.0497 67.845 48.7099L66.6177 44.3481Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4421 55.2168C46.467 55.2168 48.9178 52.8943 48.9178 50.028C48.9178 47.1617 46.467 50.2055 43.4421 50.2055C40.4172 50.2055 37.9663 47.158 37.9663 50.028C37.9663 52.8981 40.4172 55.2168 43.4421 55.2168Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 50,
    width: 21.7059,
    height: 21.7059,
    rx: 10.8529,
    fill: "#F8E437"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 50,
    width: 21.7059,
    height: 21.7059,
    rx: 10.8529,
    stroke: "#0C0C0C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.6468 60.8527C71.6468 63.7751 69.2751 66.1468 66.3527 66.1468C63.4304 66.1468 61.6462 63.2033 61.6462 63.2033M61.6462 63.2033H64.0392M61.6462 63.2033V65.8504M61.0586 60.8527C61.0586 57.9304 63.4092 55.5586 66.3527 55.5586C69.8839 55.5586 71.6468 58.5021 71.6468 58.5021M71.6468 58.5021V55.8551M71.6468 58.5021H69.2962",
    stroke: "#0C0C0C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4079_50468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.262,
    height: 59.21,
    fill: "white",
    transform: "translate(7 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostRefreshingIcon);
export default __webpack_public_path__ + "static/media/GhostRefreshingIcon.62386edef7cff135343625a09267ba3c.svg";
export { ForwardRef as ReactComponent };